import type { FC } from 'react'
import type { GetShopItems_getShopItems_lootRewardPackage_lootRewards } from '@g4g/graphql/src/shop/__generated__/GetShopItems'
import StandardLootReward from './StandardLootReward'
import { classNames } from '@g4g/utils/src/react/class-names'
import { RewardType } from '@g4g/graphql/src/shop/__generated__/globalTypes'

const RewardList: FC<{
  loot: GetShopItems_getShopItems_lootRewardPackage_lootRewards[]
  shine?: boolean
  alignmentClass?: 'justify-start' | 'justify-end'
  omitVipExpAndSpReward?: boolean
}> = ({ loot, shine, alignmentClass = 'justify-end', omitVipExpAndSpReward }) => (
  <div
    className={classNames('flex flex-wrap items-center w-full', alignmentClass)}
    data-cy="shop-cart-product-rewards-list"
  >
    {(omitVipExpAndSpReward
      ? loot.filter(
          (l) => !(l.rewardType === RewardType.VipExp || l.rewardType === RewardType.SalePoints)
        )
      : loot
    ).map((loot, i) => (
      <StandardLootReward shine={shine} animateRewardIn={false} key={i} loot={loot} />
    ))}
  </div>
)

export default RewardList
